import { Box } from '@mui/material';
import * as React from "react";

interface LogoIconProps {
  src: string; // Path to the image in public folder, e.g. "/ats-logo.svg"
  width?: number | string;
  height?: number | string;
  alt?: string;

  lightSrc?: string; // Optional prop to specify dark mode image
  lightMode?: boolean; // Optional prop to toggle dark mode
}

export const LogoIcon: React.FC<LogoIconProps> = ({
  src,
  width = "auto",
  height = "auto",
  alt = "Logo",
  lightSrc,
  lightMode = false,
}) => {
  const imageSrc = lightMode && lightSrc ? lightSrc : src;
  
  return (
    <Box
      component="img"
      src={imageSrc}
      alt={alt}
      width={width}
      height={height}
      draggable={false}
      sx={{ display: "block", maxWidth: "100%" }}
    />
  );
};
